import { render, staticRenderFns } from "./ColumnGraph.vue?vue&type=template&id=20f27cc9&"
import script from "./ColumnGraph.vue?vue&type=script&lang=js&"
export * from "./ColumnGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports